import React from 'react';
import { logout } from './../context/UserContext';

const Logout: React.FC<any> = () => {
    logout();
    return <></>;
};

export default Logout;
